/** Janela, em ms, antes do bloqueio em que o aviso de contagem regressiva é exibido. */
export const INACTIVITY_WARNING_WINDOW_MS = 60_000
